module.exports = __webpack_public_path__ + "static/media/iconConseilClasses.f525985f.svg";